import BreadCrumb from 'admin/components/molecules/BreadCrumb';
import React, { useState } from 'react';
import styled from 'styled-components';
import { createPrivateMoneyExchange } from '~/javascripts/admin/actions/private-money-exchanges';
import { useAppSelector } from '~/javascripts/admin/hooks/useApp';
import { Button } from '../../atoms/Buttons';
import Headings from '../../atoms/Headings';
import Label from '../../atoms/Label';
import Required from '../../atoms/Required';
import Select from '../../atoms/Select';
import ApiResult from '../../shared/ApiResult';

const FormWrapper = styled.div``;

const Form = styled.div`
  display: flex;
  gap: 16px;
  margin: 32px 0;
  align-items: center;
  ${Label} {
    margin: 0;
  }
  ${Select} {
    width: 350px;
  }
`;

const SelectWrapper = styled.div`
  position: relative;
`;

const SelectTitle = styled(Label)`
  position: absolute;
  left: 0;
  top: 0;
  transform: translateY(-100%);
`;

const SelectError = styled.span`
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateY(100%);
  color: ${({ theme }) => theme.colors.red[400]};
`;

const CRUMBS = [
  { value: 'ホーム', href: '/', isCurrentPage: false },
  { value: '各種設定', href: '', isCurrentPage: true },
  { value: 'マネー間交換管理', href: '/settings/private-money-exchange', isCurrentPage: false },
  { value: 'マネー間交換登録', href: '', isCurrentPage: true },
];

const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M24.7998 12L12.7998 0L12.7998 7.2L-0.00019455 7.2L-0.00019455 16.8L12.7998 16.8V24L24.7998 12Z"
      fill="#7C7C7C"
    />
  </svg>
);

const CreatePrivateMoneyExchange = () => {
  const user = useAppSelector((state) => state.user);

  const [senderId, setSenderId] = useState('');
  const [receiverId, setReceiverId] = useState('');
  const [showValidationError, setShowValidationError] = useState(false);
  const [apiResult, setApiResult] = useState({ message: '', isError: false });

  const privateMoneyOptions = (user.isServiceUser() ? user.moneys() : user.issuedMoneys()).map(
    (money) => ({ label: money.name, value: money })
  );

  const onCreate = () => {
    setShowValidationError(false);
    setApiResult({ message: '', isError: false });
    if (!senderId || !receiverId) {
      setApiResult({ message: 'マネーを選択してください', isError: true });
      return;
    }
    if (senderId === receiverId) {
      setShowValidationError(true);
      return;
    }
    createPrivateMoneyExchange({
      sender_money_id: senderId,
      receiver_money_id: receiverId,
    })
      .then(() =>
        setApiResult({
          message: 'マネー交換の設定作成に成功しました',
          isError: false,
        })
      )
      .catch((e) =>
        Promise.resolve(e).then((err) =>
          setApiResult({
            message: err?.message,
            isError: true,
          })
        )
      );
  };

  return (
    <FormWrapper>
      <BreadCrumb crumbs={CRUMBS} />
      <Headings.h5>マネー間交換登録</Headings.h5>
      <Form>
        <Label>
          マネー名
          <Required />
        </Label>
        <SelectWrapper>
          <SelectTitle>交換元</SelectTitle>
          <Select
            options={privateMoneyOptions}
            value={privateMoneyOptions.find((opt) => opt.value.id === senderId)}
            isMulti={false}
            onChange={(opt) => opt && setSenderId(opt.value.id)}
          />
        </SelectWrapper>
        <ArrowRight />
        <SelectWrapper>
          <SelectTitle>交換先</SelectTitle>
          <Select
            options={privateMoneyOptions}
            value={privateMoneyOptions.find((opt) => opt.value.id === receiverId)}
            isMulti={false}
            onChange={(opt) => opt && setReceiverId(opt.value.id)}
          />
          {showValidationError && <SelectError>同一のマネー名が選択されています</SelectError>}
        </SelectWrapper>
      </Form>
      {apiResult.message && <ApiResult message={apiResult.message} isError={apiResult.isError} />}

      <Button onClick={onCreate}>登録</Button>
    </FormWrapper>
  );
};

export default CreatePrivateMoneyExchange;
